import { MetaHTMLAttributes } from 'vue';
import { StaticInterface } from '../../../helpers/static-interface';

export interface ITpxSocialLinksUtils {
  copy(): void;
}

export interface IStaticTpxSocialLinksUtils {
  new (...args: any[]): ITpxSocialLinksUtils;
  copyLinkToClipboard(): Promise<void>;
  init(scope?: HTMLElement): void;
  nativeShare(): void;
}

/**
 * Social links utilities
 * @class
 */
export default class TpxSocialLinksUtils implements StaticInterface<IStaticTpxSocialLinksUtils, typeof TpxSocialLinksUtils> {
  #copyLinkButton: HTMLElement | null;
  #element: HTMLElement;
  #nativeShareButton: HTMLElement | null;

  /**
   * @constructor
   * @param {HTMLElement} element The navigation bar root element
   */
  constructor(element: HTMLElement) {
    this.#element = element;
    this.#copyLinkButton = this.#element.querySelector('.m-social-links__link--social-link');
    this.#nativeShareButton = this.#element.querySelector('.m-social-links__link--share');

    if (this.#copyLinkButton) {
      console.log('1')
      navigator?.permissions?.query({ name: "clipboard-write" as PermissionName })?.then(() => {
        this.#element.classList.add('m-social-links--can-copy');
      });
    }

    if (this.#nativeShareButton && navigator.share) {
      this.#element.classList.add('m-social-links--supports-native-share');
    }

    this.#addEventListeners();
  }

  #addEventListeners() {
    this.#copyLinkButton?.addEventListener('click', evt => {
      evt.preventDefault();
      this.copy();
    });

    this.#nativeShareButton?.addEventListener('click', evt => {
      evt.preventDefault();
      TpxSocialLinksUtils.nativeShare();
    });
  }

  copy() {
    TpxSocialLinksUtils.copyLinkToClipboard()
      .then(() => {
        this.#copyLinkButton?.classList.add('m-social-links__link--done');

        setTimeout(() => {
          this.#copyLinkButton?.classList.remove('m-social-links__link--done');
        }, 3000);
      });
  }

  /**
   * Copy the current link/url to the user's clipboard
   */
  static async copyLinkToClipboard(): Promise<void> {
    return await navigator.clipboard.writeText(window.location.href);
  }

  /**
   * Creates new instances of TpxSocialLinksUtils for each `.m-social-links` element,
   * and adds the necessary logic and event listeners to support native sharing and coping of link
   */
  static init(scope?: HTMLElement) {
    const socialLinks: Element[] = [...(scope || document).getElementsByClassName('m-social-links')];
    socialLinks.forEach(socialLink => {
      new TpxSocialLinksUtils(socialLink as HTMLElement);
    });
  }

  /**
   * Use native share functionality on the user's device
   */
  static nativeShare() {
    navigator.share({
      title: document.title,
      text: (document.querySelector('meta[name="description"]') as MetaHTMLAttributes)?.content,
      url: window.location.href,
    });
  }
}